import ResHero from "./components/ResHero";
import "./index.css";

function Resume() {
  return (
    <>
      <ResHero />
    </>
  );
}

export default Resume;
